export default __webpack_public_path__ + "static/media/doctors.0632df8f.jpg";